import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface TCPAConsentFieldProps {
    register: UseFormRegisterReturn;
}

/**
 * TCPA consent checkbox field
 * Displays compliance checkbox and text for mobile/home phone consent
 */
const TCPAConsentField = ({ register }: TCPAConsentFieldProps) => (
    <div className="form-control">
        <label className="cursor-pointer" htmlFor="tcpaInput">
            <div className="flex items-start gap-3">
                <input {...register} id="tcpaInput" type="checkbox" className="checkbox checkbox-primary mt-1" />
                <div className="text-sm text-base-content leading-5">
                    By checking the box I agree to receive calls and text updates and notifications from AAA Life Insurance
                    Company about my account, including via auto dialer or prerecorded voice. Consent is not required for
                    purchase. Message & data rates may apply. Message frequency may vary.
                    <button
                        type="button"
                        className="text-edit-link font-bold pt-3"
                        onClick={() => window.open("https://www.aaalife.com/privacy-policy", "_blank")}
                    >
                        Privacy Policy | AAA Life Insurance Company
                    </button>
                </div>
            </div>
        </label>
    </div>
);

export default TCPAConsentField;
